
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import CloseReasonDropdown from '../CloseReasonDropdown/CloseReasonDropdown';

const EditableCloseReason = ({ globalSwitchId, closeReason, wfItemId, onConfirm }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = () => {
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <CloseReasonDropdown
        globalSwitchId={globalSwitchId}
        closeReason={closeReason}
        onSave={handleSave}
        wfItemId={wfItemId}
        onConfirm={onConfirm}
      />
    );
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <span className="text-center">{closeReason || 'Not Selected'}</span>
      <Button variant="link" onClick={() => setIsEditing(true)}>
        Edit
      </Button>
    </div>
  );
};

export default EditableCloseReason;
